// import * as React, from "react";
import React, { useEffect, useState, useRef } from "react";


// React Bootstrap
import { Modal, Tab, Nav, Offcanvas } from 'react-bootstrap';


// Import Slider
import Slider from "react-slick";

// Import Components
import Header from "../components/HeaderComponent";
import { config } from '../config.js'
import TablePagination from "../components/TablePagination";

// Import Images
import managingImage from '../assets/images/manage-crypto-img.svg'

// Import Icons
import searchIcon from '../assets/images/icons/search-gray-icon.svg'
import arrowDownIcon from '../assets/images/icons/arrow-angle-down-small-icon.svg'
import walletDarkIcon from '../assets/images/icons/wallet-dark-gray-icon.svg'
import btcTagIcon from '../assets/images/icons/btc-tag-icon.svg'
import calendarIcon from '../assets/images/icons/calendar-arrow-icon.svg'
import arrowSmallIcon from '../assets/images/icons/arrow-angle-down-small-icon.svg'
import SelectDropdown from "../components/SelectDropdown";
import compareIcon from "../assets/images/icons/compare-icon.svg";
import whiteLogo from "../assets/images/logo-white.svg";
import bitcoinImage from "../assets/images/bitcoin-logo.svg";
import bankIcon from "../assets/images/icons/back-icon.svg";



function OtcTrade() {
    const [userCurrencyResponse, setUserCurrencyResponse] = useState([]);
    const [otcModalShow, setOtcModalShow] = useState(false);
    const [otcModalMobileShow, setOtcModalMobileShow] = useState(false);
    const [otctransectionList, setOtcTransectionList] = useState([]);
    const [labelSourceCurrencyValue, setLabelSourceCurrencyValue] = useState([]);
    // console.log(otctransectionList)
    const [otctransectionCount, setOtcTransectionCount] = useState([]);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [filterDate, setFilterDate] = useState([
        {
            startDate: new Date(),
            endDate: null,
            key: 'selection'
        }
    ]);
    const [otcTradeCreateValidation, setOtcTradeCreateValidation] = useState('')
    const [sourceCurrencyValue, setSourceCurrencyValue] = useState(false);
    const [destinationCurrencyValue, setDestinationCurrencyValue] = useState(false);
    const [otcTradeAmount, setOtcTradeAmount] = useState(false);
    const [otcRate, setOtcRate] = useState(false);
    const [otcTradeCreateValidationMessage, setOtcTradeCreateValidationMessage] = useState(false);



    const onCalendarOpen = (e) => {
        e.preventDefault();
        setIsCalendarOpen(!isCalendarOpen);
    };


    // Custom Select Source Start
    let selectSourceOptions = [
        { label: "BTC", icon: btcTagIcon },
        { label: "ETH", icon: btcTagIcon },
        { label: "BNB", icon: btcTagIcon },
        { label: "USDT", icon: btcTagIcon },
    ];

    const onSelectSource = (value) => {
        setSourceCurrencyValue(value);
        setLabelSourceCurrencyValue(value);
        setOtcTradeCreateValidation(false)
    };
    // Custom Select Source End


    // Custom Select Source Start
    // const selectDestinationOptions = [
    //     { label: "ETH", icon: btcTagIcon },
    //     { label: "BNB", icon: btcTagIcon },
    //     { label: "USDT", icon: btcTagIcon },
    //     { label: "BTC", icon: btcTagIcon },
    // ];

    const onSelectDestination = (value) => {
        // console.log("Selected Value:", value);
        let sourceCurrency = sourceCurrencyValue.currencycode;
        // console.log({ sourceCurrencyValue });
        setDestinationCurrencyValue(value);

        if (sourceCurrency == value.currencycode) {
            setOtcTradeCreateValidation('Please select diffrenct currency from source..');
            return;
        } else {

            if (sourceCurrencyValue.priceamount > 0) {
                setOtcTradeCreateValidation(false)
            }
        }
    };
    // Custom Select Source End



    // Assets Withdraw Modal Start
    const onotcModalClose = () => {
        setOtcModalShow(false);
    }
    const onotcModalShow = () => {
        setOtcModalShow(true);
    }
    // Assets Withdraw Modal End

    // Assets Withdraw Modal Start
    const onotcModalMobileClose = () => {
        setOtcModalMobileShow(false);
    }
    const onotcModalMobileShow = () => {
        setOtcModalMobileShow(true);
    }
    // Assets Withdraw Modal End
    let contentlimit = 20
    let sessionvalue = sessionStorage.getItem("logedinUser")
    sessionvalue = JSON.parse(sessionvalue);


    const handelOtcTradSearch = (e) => {
        let searchString = e.target.value;
        if (searchString.length >= 2) {
            let searchQueryString = `{
            "$or": [
                { "fromcurrencycode": { "$regex": "${searchString}", "$options": "i" } },
                { "tocurrencycode": { "$regex": "${searchString}", "$options": "i" } }
            ]
            }`;
            handelotctransectionhistory(0, contentlimit, searchQueryString)
        } else {
            handelotctransectionhistory(0, contentlimit, null)
        }
    };
    async function handelotctransectionhistory(skip = 0, limit = contentlimit, searchOtc = null) {
        try {
            let otctransectiondataapicalling
            if (searchOtc != null) {
                otctransectiondataapicalling = await fetch(config.API_BASE_URL + '/getotctrade', { method: "POST", body: `{"query":${searchOtc},"email":"${sessionvalue.email}","skip":${skip},"limit":${limit}}` });
            }
            else {
                otctransectiondataapicalling = await fetch(config.API_BASE_URL + '/getotctrade', { method: "POST", body: `{"email":"${sessionvalue.email}","skip":${skip},"limit":${limit}}` });
            }
            let otctransectiondata = await otctransectiondataapicalling.json()
            setOtcTransectionList(otctransectiondata.data.details);
            setOtcTransectionCount(otctransectiondata.data.transectioncount)
        } catch (err) {
            setOtcTransectionList([]);
            setOtcTransectionCount(0);
        }
    }
    useEffect(() => {
        setOtcTradeCreateValidation(false);
        setOtcTradeCreateValidationMessage(false);
        hendelusercurrencyres();
    }, [])
    async function hendelusercurrencyres() {
        if (sessionvalue) {
            let usercurrencydata = await fetch(config.API_BASE_URL + '/getuserwisecurrency', { method: 'POST', body: JSON.stringify(sessionvalue) });
            let res = await usercurrencydata.json();

            setUserCurrencyResponse(res.data);

        }
    }
    async function otcAmount(e, otcvalidation) {
        try {
            let value = e.target.value;
            let source = userCurrencyResponse.filter(res => (res.currencycode).toLowerCase() == (sourceCurrencyValue.currencycode).toLowerCase())[0];
            if (source.priceamount < value) {
                setOtcTradeCreateValidation("Don not have sufficient balance for trade..");
                return;
            }
            setOtcTradeCreateValidation(false);
            if (otcvalidation == 'otcAmount') {
                setOtcTradeAmount(value)
            }
            if (otcvalidation == 'otcRate') {
                setOtcRate(value);
            }
        }
        catch (err) {
            console.log(err);
        }
    }
    async function handelotcTradeCreate(e) {

        let value;

        if(e =='sell' || e =='buy'){
            value= e;

        }else{
            value = e.target.value;
        }
        let usdCurrency = userCurrencyResponse.filter(res => res.currencycode == 'USD')[0];


        if (value == 'sell') {
            if(sourceCurrencyValue.currencycode == 'USD'){
                setSourceCurrencyValue(labelSourceCurrencyValue);
            }
            setDestinationCurrencyValue(usdCurrency)
            
           
        }
        if (value == 'buy') {
            setDestinationCurrencyValue(sourceCurrencyValue)
            setSourceCurrencyValue(usdCurrency)
        }
        console.log({value,sourceCurrencyValue});
        
    }
    useEffect(()=>{
        if (sourceCurrencyValue.priceamount == 0 || sourceCurrencyValue.priceamount == 0) {
            setOtcTradeCreateValidation('There low balance in your selected source currency..');
            return;
        } else {
            setOtcTradeCreateValidation(false)

        }
        if (destinationCurrencyValue) {
            let destinationCurrency = destinationCurrencyValue.currencycode;
            if (destinationCurrency == sourceCurrencyValue.currencycode) {
                setOtcTradeCreateValidation('Please select different currency from source..');
                return;
            } else {
                setOtcTradeCreateValidation(false)
            }
        }
    },[destinationCurrencyValue,sourceCurrencyValue])
    async function handelotctransectionopration() {
        try {
            const selectedRadioValue = document.querySelector('input[name="sellbuyradiobutton"]:checked')?.value;
            handelotcTradeCreate(selectedRadioValue);
            if (sourceCurrencyValue && destinationCurrencyValue) {
                // console.log("aaaaaaaaaaaaaaaa", otctransectionList.map(res => res.fromcurrencycode == sourceCurrencyValue.currencycode && res.tocurrencycode == destinationCurrencyValue.currencycode && res.status == 'pending'))
                if (otctransectionList.map(res => res.fromcurrencycode == sourceCurrencyValue.currencycode && res.tocurrencycode == destinationCurrencyValue.currencycode && res.status == 'pending')[0]) {
                    setOtcTradeCreateValidationMessage('As per selected currency and amount already under process please wait for approvel..');
                } else {
                    setOtcTradeCreateValidation(false);
                    let requestparameters = `{
                    "email": "${sessionvalue?.email}",
                    "fromcurrencycode": "${sourceCurrencyValue.currencycode}",
                    "fromcurrencyname": "${sourceCurrencyValue.currencyname}",
                    "tocurrencycode": "${destinationCurrencyValue.currencycode}",
                    "tocurrencyname": "${destinationCurrencyValue.currencyname}",
                    "priceamount": "${otcTradeAmount}",
                    "conversionrate": "${otcRate}",
                    "transactiontype": " ${sourceCurrencyValue.currencyname}-> ${destinationCurrencyValue.currencyname}",
                    "status": "Pending",
                    "type": "${sourceCurrencyValue.type} -> ${destinationCurrencyValue.type}"
                    }`
                    let usercurrencydata = await fetch(config.API_BASE_URL + '/updateinsertotctrade', { method: 'POST', body: requestparameters });
                    console.log({ usercurrencydata });
                    setDestinationCurrencyValue(null)
                    setSourceCurrencyValue(null)
                    window.location.href = '/otc-trade';
                }
            }
            else {
                // setOtcTradeCreateValidation(true);
                setOtcTradeCreateValidationMessage('Please select source and destination currency..');
            }
        } catch (err) {
            console.log(err);
        }
    }
    return (
        <div className='home-page'>
            <Header />
            <section className="sec-banner">
                <div className="container-fluid">
                    <div className="banner-wrapper">
                        <div className="top-notch-wrapper">
                            <span className="top-notch"></span>
                            <a href="#" className="logo">
                                <img src={whiteLogo} alt="logo" />
                            </a>
                        </div>
                        <div className="container">
                            <div className="otc-banner-wrapper">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h2 className="w-500">OTC Trade</h2>
                                    </div>
                                    <div className="col-md-6">
                                        <ul className="btn-list">
                                            <li className="d-none d-md-block"><a href="#" className="btn-style white" onClick={onotcModalShow}>+ Create New OTC Trade Request</a></li>
                                            <li className="d-block d-md-none"><a href="#" className="btn-style white" onClick={onotcModalMobileShow}>+ Create New OTC Trade Request</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="sec-wallet sec-otc-wallet">
                <div className="container">
                    <div className="wallet-wrapper">
                        <div className="wallet-wrapper-table">
                            <div className="asset-wrapper">
                                <div className="asset-header">
                                    <h3 className="f-30 w-400 h-font title">Transaction History</h3>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-4 order-2 order-md-1 align-self-center">
                                            <div className="otc-search-wrapper">
                                                <div className="search-wrapper-v1">
                                                    <div className="form">
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" placeholder="Search" onChange={(e) => handelOtcTradSearch(e)} />
                                                            <img src={searchIcon} className="icon" alt="icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <a href="#" className="btn-style show-mobile transparent">Show All Assets</a>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-8 order-1 order-md-2 align-self-center">
                                            <div className="filter-wrapper">
                                                <ul className="btn-list otc-btn-list">
                                                    {/* <li>
                                                        <a href="#" className="btn-style date-btn icon transparent" onClick={onCalendarOpen}>
                                                            <img src={calendarIcon} className="calendar-icon" alt="icon" />
                                                            Select Date Range
                                                            <img src={arrowSmallIcon} className="arrow-icon" alt="icon" />
                                                        </a>
                                                        {isCalendarOpen && (
                                                            <div className="select-date">
                                                                <div className="select-date-wrapper">
                                                                    <DateRange
                                                                        editableDateInputs={false}
                                                                        onChange={item => {
                                                                            console.log(item)
                                                                            setFilterDate([item.selection]);
                                                                        }}
                                                                        moveRangeOnFirstSelection={false}
                                                                        ranges={filterDate}
                                                                    />
                                                                    <div className="btn-wrapper">
                                                                        <ul className="btn-list">
                                                                            <li>
                                                                                <a href="#" className="btn-style transparent" onClick={(e) => {
                                                                                    e.preventDefault()
                                                                                    setIsCalendarOpen(false)
                                                                                }}>
                                                                                    Cancel
                                                                                </a>
                                                                            </li>
                                                                            <li>
                                                                                <a href="#" className="btn-style orange-btn" onClick={(e) => {
                                                                                    e.preventDefault()
                                                                                    setIsCalendarOpen(false)
                                                                                }}>
                                                                                    Continue
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </li>
                                                    <li><a href="#" className="btn-style">Download Report</a></li> */}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="asset-body">
                                    <div className="asset-list-wrapper">
                                        <div className="asset-list desktop">
                                            <div className="table-header style-v2 Otc-grid-8">
                                                <div className="asset-item p-0">

                                                </div>
                                                <div className="asset-item">
                                                    <p>Source Asset</p>
                                                </div>
                                                <div className="asset-item">
                                                    <p>Destination Asset</p>
                                                </div>
                                                <div className="asset-item">
                                                    <p>Amount</p>
                                                </div>
                                                <div className="asset-item">
                                                    <p>Exchange Rate</p>
                                                </div>
                                                <div className="asset-item">
                                                    <p>Status</p>
                                                </div>
                                                <div className="asset-item">
                                                    <p>Created on</p>
                                                </div>
                                                <div className="asset-item">
                                                    <p>Approved on</p>
                                                </div>
                                            </div>
                                            {otctransectionList && otctransectionList.length > 0 ? otctransectionList.map(res => {

                                                return <div className="asset-card Otc-grid-8">
                                                    <div className="asset-item">

                                                    </div>
                                                    <div className="asset-item">
                                                        <p className="p w-500">{res.fromcurrencycode}</p>
                                                    </div>
                                                    <div className="asset-item">
                                                        <p className="p w-500">{res.tocurrencycode}</p>
                                                    </div>
                                                    <div className="asset-item">
                                                        <p className="p w-500">{res.priceamount} {res.tocurrencycode}</p>
                                                    </div>
                                                    <div className="asset-item">
                                                        <p className="p w-500">{res?.conversionrate || '-'}</p>
                                                    </div>
                                                    <div className="asset-item">
                                                        <p className="p w-500">{res.status}</p>
                                                    </div>
                                                    <div className="asset-item">
                                                        <p className="p w-500">{res.createdAt}</p>
                                                    </div>
                                                    <div className="asset-item">
                                                        <p className="p w-500">{res.approveAt ?? '-'}</p>
                                                    </div>
                                                </div>
                                            }) : "No Result!!"}
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <TablePagination totalData={otctransectionCount} pageLimit={contentlimit} onPageChange={handelotctransectionhistory} otcTrade='true' />

            {/* Assets Withdraw Funds Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal assets-withdraw-funds-modal" show={otcModalShow} onHide={onotcModalClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <h3 className="h3">OTC Trade</h3>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="otc-compare-wrapper">
                                    <div className="deposit-item">
                                        <h3>Source </h3>
                                        {userCurrencyResponse &&
                                            <SelectDropdown
                                                options={userCurrencyResponse.map(res => {
                                                    if ((res.currencycode).toLowerCase() == "usd") { return undefined }
                                                    return { label: `${res.currencycode}-USD`, ...res }
                                                }).filter(res => res !== undefined)}
                                                onSelect={onSelectSource}
                                                placeholder="Choose Asset"
                                                placeholderIcon={btcTagIcon}
                                                className="otc-dropdown"
                                                showIcon={false}
                                            />}
                                        {(otcTradeCreateValidation || otcTradeCreateValidationMessage) && (
                                            <span className="top-notch text-danger">
                                                {otcTradeCreateValidation || otcTradeCreateValidationMessage}
                                            </span>
                                        )}
                                    </div>

                                    <div className="compare-icon">
                                        {/* <img src={compareIcon} alt="icon" /> */}
                                    </div>
                                    <div className="deposit-item">
                                        <h3>Destination</h3>
                                        {userCurrencyResponse && <><label>Sell From {labelSourceCurrencyValue?.currencycode} to USD ㅤ</label>
                                            <input type="radio" name="sellbuyradiobutton" value="sell" onChange={handelotcTradeCreate} defaultChecked />
                                            <br /><label>Buy From USD to {labelSourceCurrencyValue?.currencycode}ㅤ</label>
                                            <input type="radio" name="sellbuyradiobutton" value="buy" onChange={handelotcTradeCreate} /></>}
                                    </div>
                                </div>
                                <div className="otc-compare-wrapper">

                                    <div className="form">
                                        Source Currency Rate
                                        <div className="form-group">
                                            <input type="number" className="form-control" onChange={(e) => otcAmount(e, "otcAmount")} placeholder="Enter Amount" />
                                        </div>
                                    </div>
                                    <h3></h3>
                                    <div className="form">
                                        Currency Rate
                                        <div className="form-group">
                                            <input type="number" className="form-control" onChange={(e) => otcAmount(e, "otcRate")} placeholder="Enter Rate" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                {!otcTradeCreateValidation &&
                                    <li><a href="#" className="btn-style" onClick={handelotctransectionopration}>Submit Request</a></li>}
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Assets Withdraw Funds Modal End */}


            {/* Assets Withdraw Funds Mobile Modal Start */}
            {/* <Offcanvas show={otcModalMobileShow} className="deposit-select-wallet-modal h-510" onHide={onotcModalMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    ///<Offcanvas.Title>Offcanvas</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <h3 className="h3">OTC Trade</h3>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="otc-compare-wrapper">
                                    <div className="deposit-item">
                                        <h3>Source</h3>
                                        <SelectDropdown
                                            options={selectSourceOptions}
                                            onSelect={onSelectSource}
                                            placeholder="Choose Asset"
                                            placeholderIcon={btcTagIcon}
                                            className="otc-dropdown"
                                            showIcon={false}
                                        />
                                    </div>
                                    <div className="compare-icon">
                                        <img src={compareIcon} alt="icon" />
                                    </div>
                                    <div className="deposit-item">
                                        <h3>Destination</h3>
                                        <SelectDropdown
                                            options={selectDestinationOptions}
                                            onSelect={onSelectDestination}
                                            placeholder="Choose Asset"
                                            placeholderIcon={btcTagIcon}
                                            className="otc-dropdown"
                                            showIcon={false}
                                        />
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Amount</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter Amount" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style">Submit Request</a></li>
                            </ul>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas> */}
            {/* Assets Withdraw Funds Mobile Modal End */}
        </div>
    )
}

export default OtcTrade
